import React from "react";
import { Button as SemanticButton, Checkbox, Icon, Popup } from "semantic-ui-react";
import i18nstring, { strings } from "../../i18n";
import "./MoleculeStyles.scss";
import { FormSectionLargeInput } from "../atoms/FormFields";
import SectionHeading from "./SectionHeading";
import { Button } from "../atoms/Button";

const OFFER_ITEMS = [
	{
		key: "dropoff",
		labelKey: strings.OFFER_DROPOFF,
		nameKey: strings.OFFERS_DROP_OFF,
		infoKey: strings.OFFERS_DROP_OFF_INFO,
		tooltipKey: strings.OFFER_DROPOFF_TOOLTIP
	},
	{
		key: "pickup",
		labelKey: strings.OFFER_PICKUP,
		nameKey: strings.OFFER_PICKUP,
		infoKey: strings.OFFERS_PICKUP_INFO,
		tooltipKey: strings.OFFER_PICKUP_TOOLTIP
	}
];

function OfferOptionCard({ offer, enabled, onToggle }) {
	return (
		<div className={`offer_choice_card ${enabled ? "is_enabled" : "is_disabled"}`}>
			<div className="offer_choice_card_main">
				<div className="offer_choice_card_title_row">
					<div className="offer_choice_card_title_group">
						<div className="offers_checkbox_label offer_choice_card_title">
							{i18nstring(offer.labelKey)}
							<Popup
								content={i18nstring(offer.tooltipKey)}
								trigger={
									<Icon
										className="offers_info_icon"
										name="question circle outline"
									/>
								}
							/>
						</div>
					</div>
					<Checkbox
						className="offer_choice_toggle"
						toggle
						label=""
						name={i18nstring(offer.nameKey)}
						checked={enabled}
						onChange={onToggle}
					/>
				</div>
				<p className="offers_checkbox_label_info offer_choice_card_description">
					{i18nstring(offer.infoKey)}
				</p>
			</div>
		</div>
	);
}

export function EnablePickupDropoff(props) {
	const handleSaveClick = () => {
		if (props.isSaveDisabled) {
			return;
		}

		props.onSave?.();
	};

	const toggleOffer = offerKey => {
		if (offerKey !== "dropoff" && offerKey !== "pickup") return;

		if (offerKey === "dropoff") {
			props.onDropoffChange?.(!props.dropoff);
			return;
		}

		if (offerKey === "pickup") {
			props.onPickupChange?.(!props.pickup);
		}
	};

	const handleInputChange = e => {
		props.onInstructionsChange?.(e.target.value);
	};

	const offerState = {
		dropoff: props.dropoff,
		pickup: props.pickup
	};

	return (
		<>
			<div className="locations_table_layout enable_pickup_dropoff_alt_layout">
				<div className="locations_table_sidebar">
					<SectionHeading title={i18nstring(strings.OFFERS)} />
				</div>
				<div className="locations_table_divider" />
				<div className="locations_table_content enable_pickup_dropoff_alt_content">
				<div className="offers_sub_header">{i18nstring(strings.OFFERS_INFO)}</div>

				<div className="offer_choice_board">
					{OFFER_ITEMS.map(offer => {
						const enabled = offerState[offer.key];

						return (
							<OfferOptionCard
								key={offer.key}
								offer={offer}
								enabled={enabled}
								onToggle={() => toggleOffer(offer.key)}
							/>
						);
					})}
				</div>

				{!props.pickup && !props.dropoff && (
					<div className="offer_choice_notice">
						<div className="offer_choice_notice_header">
							<div className="offers_checkbox_label">
								{i18nstring(strings.OFF_SEASON_MESSAGE)}
								<Popup
									content={i18nstring(strings.OFF_SEASON_MESSAGE_TOOLTIP)}
									trigger={
										<Icon
											className="offers_info_icon"
											name="question circle outline"
										/>
									}
								/>
							</div>
							<span className="offer_choice_notice_badge">Required</span>
						</div>
						<div className="offer_choice_notice_body">
							<label className="offers_textbox_label_info">
								{i18nstring(strings.OFFERS_DISABLED_INSTRUCTIONS_NOTE)}
							</label>
							<FormSectionLargeInput
								name="offersDisabledInstructions"
								placeholder={i18nstring(
									strings.OFFERS_DISABLED_INSTRUCTIONS_GARDENER
								)}
								onChange={handleInputChange}
								maxChar={600}
								value={props.offersDisabledInstructions ?? ""}
							/>
						</div>
					</div>
				)}

				{!props.save && (
					<div className="locations_create_button_row">
						<SemanticButton type="submit" onClick={props.onNext} floated="right">
							{i18nstring(strings.NEXT)}
						</SemanticButton>
					</div>
				)}

				</div>
			</div>

			{props.save && (
				<div className="locations_table_layout locations_table_layout_no_border">
					<div className="locations_table_sidebar" />
					<div className="locations_table_divider" />
					<div className="locations_table_content">
						<div className="locations_create_button_row">
							<Button
								disabled={props.isSaveDisabled}
								onClick={handleSaveClick}
							>
								{i18nstring(strings.SAVE_CHANGES)}
							</Button>
						</div>
					</div>
				</div>
			)}
		</>
	);
}
